import React from 'react'
import Alert from 'sweetalert2'
import { toast } from 'react-toastify'
import { funnelTemplateIDFromPresetID } from '@marketing-milk/interfaces'
import PresetActions from 'app/redux/actions/data/funnel/presets'
import { funnelTemplateService } from 'app/service/funnel-template'

interface Interface {
  id: number
  name: string
  icon: string
  desc: string
  stages: Array<any>
  active: boolean
  modify: () => void
}

export default ({ id, name, icon, desc, modify }: Interface) => {
  // Built-in presets have ids 1-4; a user's saved template is offset past
  // FUNNEL_TEMPLATE_PRESET_ID_OFFSET, so this is also "is this deletable".
  const templateID = funnelTemplateIDFromPresetID(id)

  const onDelete = async (event: React.MouseEvent) => {
    // The whole card is the click target, so without this the confirm would
    // race with applying the preset it is about to delete.
    event.stopPropagation()

    // @ts-ignore - The types are confusing the compiler
    const result = await Alert.fire({
      title: 'Are you sure?',
      text: `This will delete the "${name}" template`,
      type: 'question',
      showCancelButton: true,
      cancelButtonColor: '#36a3f7',
      confirmButtonText: 'Yes, delete this template',
      confirmButtonColor: '#f4516c',
      focusCancel: true,
    })

    if (!result.value || templateID === null) {
      return
    }

    try {
      await funnelTemplateService.delete(templateID)
      PresetActions.remove(templateID)
      toast.success('Template deleted')
    } catch {
      toast.error('Unexpected error occurred while deleting the template.')
    }
  }

  return (
    <div className="kt-portlet kt-portlet--height-fluid portlet-as-button" onClick={modify}>
      <div className="kt-portlet__body">
        <div className="kt-widget kt-widget--user-profile-2">
          <div className="kt-portlet__head kt-portlet__head--noborder">
            <div className="kt-portlet__head-label">
              <h1 className="kt-portlet__head-title text-brand">
                {/* Presets store a full class string ('fas fa-cogs'), so the old
                    `fa fa-${icon}` rendered 'fa fa-fas fa-cogs' and showed no
                    icon at all. */}
                <i className={`${icon} mr-2`} />
                {name}
              </h1>
            </div>
            {templateID !== null && (
              <div className="kt-portlet__head-toolbar">
                <button
                  type="button"
                  aria-label={`Delete ${name} template`}
                  className="btn btn-icon btn-sm btn-clean"
                  onClick={onDelete}
                >
                  <i className="fas fa-times" />
                </button>
              </div>
            )}
          </div>
          <div className="kt-widget__body">
            <div className="kt-widget__section">{desc}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
